import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9de23f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "information-section",
  id: "information-section"
}
const _hoisted_2 = { class: "column-info wrapper-img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "column-info wrapper-text-information" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.infos.title), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infos.infosList, (info, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "wrapper-item",
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: require('@/assets/info/' + info.img),
            alt: "",
            class: "image-information"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(info.text), 1)
        ])
      ]))
    }), 128))
  ]))
}